import { useAuthContext } from '../../context/auth/auth'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BillingInformation } from '../../interfaces/billingInformation'
import instance from '../api'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

const updateBillingInformation = async (
  values: Omit<BillingInformation, 'id'>,
  token: string,
  billingInformationId: number,
) => {
  const sanitizedValues = Object.fromEntries(
    Object.entries(values).filter(
      ([_, value]) => value !== undefined && value !== '',
    ),
  )

  return instance.patch(
    `/auth/billing-address/${billingInformationId}/`,
    sanitizedValues,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
}

const useUpdateBillingInformation = () => {
  const { token } = useAuthContext()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: ({
      values,
      billingInformationId,
    }: {
      values: Omit<BillingInformation, 'id'>
      billingInformationId: number
    }) => updateBillingInformation(values, token!, billingInformationId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['billingInformation'],
      })
      toast.success(t('billingInformationHasBeenUpdated'))
    },
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data.data?.[0])
        return
      }
      toast.error(t('somethingWentWrongPleaseTryAgain'))
    },
  })
}

export default useUpdateBillingInformation
